import { selectFactory } from '../../helpers';

import * as Constants from '../constants';

import { collectValueFields, selectFields, selectFromCollect } from './helpers';

export const selectData = selectFields(Constants.FIELDS.DATA);

export const selectDataField = selectFactory({ selector: selectData });

export const selectDataDisabled = collectValueFields({
  field: Constants.DATA_VALUE_FIELDS.DISABLED,
  selector: selectData,
});

export const selectDataErrors = collectValueFields({
  field: Constants.DATA_VALUE_FIELDS.ERROR,
  selector: selectData,
});

export const selectDataHidden = collectValueFields({
  field: Constants.DATA_VALUE_FIELDS.HIDDEN,
  selector: selectData,
});

export const selectDataValues = collectValueFields({
  field: Constants.DATA_VALUE_FIELDS.VALUE,
  selector: selectData,
});
export const selectDataValue = selectFromCollect({ selector: selectDataValues });
